<template>
  <div id="app">
    <!-- If not authenticated, show the Login component -->
    <div v-if="!isAuthenticated">
      <Login @login-success="handleLoginSuccess" />
    </div>
    <!-- Once authenticated, display header with Logout and the main app -->
    <div v-else>
      <header>
        <button @click="logout" class="logout-btn">Logout</button>
      </header>
      <router-view />
    </div>
  </div>
</template>

<script>
import Login from "./views/Login.vue"
import auth0 from "./authService"

export default {
  name: "App",
  components: {
    Login
  },
  data() {
    return {
      isAuthenticated: false,
      user: null,
      error: null
    }
  },
  methods: {
    handleLoginSuccess(userData) {
      this.user = userData
      this.isAuthenticated = true
    },
    logout() {
      localStorage.removeItem("idToken")
      localStorage.removeItem("expiresAt")
      localStorage.removeItem("userEmail")
      this.isAuthenticated = false
      this.user = null
      window.location.reload()
    },
    setSession(authResult) {
      localStorage.setItem("idToken", authResult.idToken)
      const expiresAt = new Date().getTime() + authResult.expiresIn * 1000
      localStorage.setItem("expiresAt", expiresAt)
      localStorage.setItem("userEmail", authResult.idTokenPayload.email)
      this.user = authResult.idTokenPayload
      this.isAuthenticated = true
    }
  },
  mounted() {
    // Check if returning from Auth0 (tokens in URL hash)
    if (window.location.hash && window.location.hash.includes("access_token")) {
      auth0.parseHash((err, authResult) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          window.location.hash = ""  // Clean the hash from the URL
          this.setSession(authResult)
        } else if (err) {
          console.error("Error parsing hash:", err)
          this.error = err
        }
      })
    } else {
      // Check if a valid session exists in localStorage
      const idToken = localStorage.getItem("idToken")
      const expiresAt = localStorage.getItem("expiresAt")
      if (idToken && new Date().getTime() < expiresAt) {
        this.user = { email: localStorage.getItem("userEmail") }
        this.isAuthenticated = true
      }
    }
  }
}
</script>

<style>
.logout-btn {
  margin: 10px;
  padding: 10px 20px;
  background-color: #ff4d4d;
  color: #ffffff;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}
</style>